import { render, staticRenderFns } from "./_Emission.vue?vue&type=template&id=bcf6aa8a&"
import script from "./_Emission.vue?vue&type=script&lang=js&"
export * from "./_Emission.vue?vue&type=script&lang=js&"
import style0 from "./_Emission.vue?vue&type=style&index=0&id=bcf6aa8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports